import styled from "styled-components";

export const LojaStyle = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
`;

export const LojaCardStyle = styled.div`
  background-color: white;
  padding: ${(props) => (props.isPadrao === false ? `4rem 2rem 4rem 2rem` : `2rem 2rem 2rem 2rem`)};
  border-radius: 15px;
  -webkit-box-shadow: 9px 7px 9px -5px rgb(97 96 96 / 35%);
  box-shadow: 9px 7px 9px -5px rgb(97 96 96 / 35%);
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    padding-top: 6px;
    padding-bottom: 6px;
    text-align: center;
  }

  .ePadrao {
    font-weight: 400;
    font-size: 1.2em;
    color: #9339a2;
  }

  .nomeDaLoja {
    font-weight: 600;
    font-size: 1.1em;
  }

  .enderecoLoja {
    text-align: center;
    font-size: 0.9em;
    color: #666;
    margin-bottom: 6px;
  }

  ion-icon {
    font-size: 22px;
    color: #9339a2;
    vertical-align: middle;
  }

  .status-loja {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-weight: 600;
    font-size: 0.9em;
    margin-top: 6px;
    margin-bottom: 6px;
  }

  .status-loja.ativa {
    color: #9339a2;
  }

  .status-loja.desativada {
    color: #9339a2;
  }

  .button {
    margin-top: 10px;
    margin-bottom: 4px;
    width: 65%;
    font-weight: 600;
    font-size: 0.9em;
    letter-spacing: 0.3px;
    border: none;
    border-radius: 6px;
    padding: 10px;
  }

  .btn-principal {
    background: rgb(131, 43, 146);
    background: linear-gradient(267deg, rgba(131, 43, 146, 1) 39%, rgba(160, 69, 176, 1) 100%);
    color: white;
    -webkit-box-shadow: 9px 7px 9px -5px rgb(97 96 96 / 32%);
    box-shadow: 9px 7px 9px -5px rgb(97 96 96 / 32%);
  }

  .btn-principal:hover {
    background: rgb(160, 69, 176);
    background: linear-gradient(267deg, rgba(160, 69, 176, 1) 39%, rgba(131, 43, 146, 1) 100%);
    color: white;
  }

  .btn-secundario {
    background: rgb(131, 43, 146);
    background: linear-gradient(267deg, rgba(131, 43, 146, 1) 39%, rgba(160, 69, 176, 1) 100%);
    color: white;
    -webkit-box-shadow: 9px 7px 9px -5px rgb(97 96 96 / 32%);
    box-shadow: 9px 7px 9px -5px rgb(97 96 96 / 32%);
  }

  .btn-secundario:hover {
    background: rgb(160, 69, 176);
    background: linear-gradient(267deg, rgba(160, 69, 176, 1) 39%, rgba(131, 43, 146, 1) 100%);
    color: white;
  }

  @media (max-width: 1440px) {
    padding: ${(props) =>
      props.isPadrao === false ? `3rem 1rem 3rem 1rem` : `1rem 1rem 1rem 1rem`};
  }

  @media (max-width: 770px) {
    width: auto;
  }
`;
